/* Analytics (docs/plans/phase3-deeper-analytics.md §5). Tokens only; readable at 1366x768
   without the page scrolling sideways (wide tables scroll inside their card). */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
}

/* Fields line up by their inputs; "Show" sits on the input line, as in the reports. */
.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--space-3) var(--space-4);
}

.filters > * {
  flex: 0 1 14rem;
  min-width: 0;
}

.filters > :last-child {
  flex: 0 0 auto;
  padding-top: calc(22px + var(--space-1));
}

.resultHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.summary {
  max-width: 75ch;
  margin: 0;
  font: var(--t-body);
  font-variant-numeric: tabular-nums;
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

/* Two charts side by side when there is room, one per row on narrow screens. */
.charts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 22rem), 1fr));
  gap: var(--space-5);
}

.id {
  font-family: var(--font-id);
  font-variant-numeric: tabular-nums;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
